import React from 'react';

import { Section, preloader } from 'spectacle-ppa';
import videoSlide from '../../baseSlides/videoSlide';
import balloonSlide from '../../baseSlides/balloonSlide';

import apprenticePointingDiagonal from '../../images/characters/apprenticePointingDiagonal.png';
import apprenticesFlexArms from '../../images/characters/apprenticesFlexArms.png';

import MarkdownScript from 'helpers/markdownScript';
import markdownFile from './song.md';

const md = new MarkdownScript(markdownFile);

export function preloadSong () {
  preloader([
    apprenticePointingDiagonal,
    apprenticesFlexArms
  ]);
}

function songSection ({ regionData }) {
  return (
    <Section id="song">

      {/* Congratulations */}
      {balloonSlide({
        id: 'congratulations',
        characterSide: 'right',
        characterImage: apprenticesFlexArms,
        html: md.getSubSectionAsHtml('Congratulations', 'Content', false, regionData),
        notes: md.getSubSectionAsHtml('Congratulations', 'Notes', false, regionData)
      })}

      {/* Song intro */}
      {balloonSlide({
        id: 'song-intro',
        characterSide: 'right',
        characterImage: apprenticePointingDiagonal,
        html: md.getSubSectionAsHtml('Song Intro', 'Content', false, regionData),
        notes: md.getSubSectionAsHtml('Song Intro', 'Notes', false, regionData)
      })}

      {/* Song */}
      {videoSlide({
        id: 'song',
        notes: md.getSubSectionAsHtml('Song', 'Notes', false, regionData),
        youTubeId: md.getSectionMetadata('Song', 'YouTube', regionData)
      })}

    </Section>
  );
}

export default songSection;



// WEBPACK FOOTER //
// ./programs/epsHybridAssembly/sections/03_song/songSection.jsx